'use client'

import { Card } from '@inflow/ui/components/card'
import { Carousel, CarouselContent, CarouselItem } from '@inflow/ui/components/carousel'
import { motion } from 'motion/react'
import { containerStagger, fadeUp } from '../base-animations'
import { NavLink } from '../components/NavLink'
import Section from './Section'

const MotionCard = motion(Card)
const MotionNavLink = motion(NavLink)

const content = [
  'Few analysts read the macro landscape like Gerard Minack; his work has been indispensable for understanding cycles and positioning ahead of major shifts.',
  'This research blends clarity, data, and decades of experience — he explains complex global trends in both an actionable and refreshingly independent.',
  'Gerard Minack has an unmatched ability to cut through the noise and identify the real macro drivers that matter — his insights consistently anticipate market turns.',
]

export default function AboutGerard() {
  return (
    <Section
      title="About Gerard"
      action={
        null
        // <MotionNavLink href="/about">
        //   <Button>Discover our story</Button>
        // </MotionNavLink>
      }
    >
      <motion.div
        className="grid grid-cols-1 grid-rows-[auto_auto] items-center justify-items-center gap-6 lg:grid-cols-[auto_2fr] lg:grid-rows-1"
        variants={containerStagger(0.3)}
        initial="hidden"
        whileInView="visible"
        viewport={{
          once: true,
          amount: 0.1,
          margin: '-10% 0px -10% 0px',
        }}
      >
        <MotionCard
          className="grid h-62 max-h-[550px] w-62 content-center justify-items-center gap-8 rounded-full bg-center bg-cover"
          style={{ backgroundImage: "url('/images/gerard-1.png')" }}
          variants={fadeUp()}
        />
        <motion.div
          variants={fadeUp()}
          className="max-w-full"
        >
          <Carousel>
            <CarouselContent>
              {content.map((item) => (
                <CarouselItem key={item}>
                  <Card className="h-full items-center justify-center border-none p-9">
                    <h4 className="text-center text-2xl">"{item}"</h4>
                  </Card>
                </CarouselItem>
              ))}
            </CarouselContent>
          </Carousel>
        </motion.div>
      </motion.div>
    </Section>
  )
}
